const disableEventHandler = (event) => {
  event.preventDefault();
  event.stopPropagation();
};
const onClickHandler = (event) => {
  if (event.path && event.path.slice(0, 5).some((el) => el instanceof HTMLAnchorElement)) {
    event.preventDefault();
    event.stopPropagation();
  }
};
export {
  disableEventHandler,
  onClickHandler
};
//# sourceMappingURL=eventHandlers.js.map
